export * from './sr-label'